module.exports = __webpack_public_path__ + "img/contract-erased.d5aef10c.webp";